import Scrollable from "components/common/ui/Scrollable/Scrollable";
import { ProductCustomField } from "ts/types";
import SisterColourSKU from "./SisterColourSKU/SisterColourSKU";
import { VariantsList, VariantsListNoTileMode, VariantsWrapper } from "./SisterColourSKUs.Styled";
import { FunctionComponent } from "react";

interface SisterSKUsProps {
	field: ProductCustomField;
	displayNoTitle?: boolean;
}

const SisterColourSKUs: FunctionComponent<SisterSKUsProps> = ({ field, displayNoTitle = false }) => {
	const skus = field.value.split(",");

	return (
		<VariantsWrapper>
			<Scrollable>
				{
					displayNoTitle? //if is display with noTitle mode
					
						<VariantsListNoTileMode>
							{skus.map((sku) => (
								<SisterColourSKU key={sku} sku={sku} displayNoTitle={displayNoTitle}/>
							))}
						</VariantsListNoTileMode>
					

					: // if is not display with noTitle mode
						<VariantsList>
							{skus.map((sku) => (
								<SisterColourSKU key={sku} sku={sku}/>
							))}
						</VariantsList>
				}
			</Scrollable>
		</VariantsWrapper>
	);
};

export default SisterColourSKUs;
